// extracted by mini-css-extract-plugin
export default {"smallLogo":"components-Header-themes-PP-stylesLogo__smallLogo--xzdKF"};